import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { PackageService } from '../../../api/packageService';
import { PackageResponse } from '../../../@type/package.types';
import SelectField from '../../../components/common/fields/SelectField';

interface Props {
  value: number | null;
  /** Package being edited (cannot inherit from itself) */
  excludeId?: number;
  onChange: (value: number | null) => void;
}

/** Dropdown to choose the package whose features this package includes. */
const InheritsPackageSelect: React.FC<Props> = ({ value, excludeId, onChange }) => {
  const { t } = useTranslation();
  const [packages, setPackages] = useState<PackageResponse[]>([]);

  useEffect(() => {
    PackageService.getAllPackages()
      .then((response) => setPackages(response?.data?.data ?? []))
      .catch((error) => console.error('Failed to load packages:', error));
  }, []);

  const options = packages
    .filter((pkg) => pkg.id !== excludeId)
    .map((pkg) => ({ value: pkg.id, label: pkg.name }));

  return (
    <Box sx={{ mt: 2 }}>
      <Box component="label" sx={{ display: 'block', mb: 0.5, fontSize: '14px' }}>
        {t('packages.inheritsPackage')}
      </Box>
      <SelectField
        value={value}
        searchable={false}
        matchAnchorWidth
        emptyLabel={t('packages.inheritsPackageNone')}
        options={options}
        onChange={(selected) => onChange(selected === null ? null : Number(selected))}
      />
      <Box sx={{ mt: 0.5, fontSize: '12px', color: '#8c8c8c' }}>
        {t('packages.inheritsPackageHelp')}
      </Box>
    </Box>
  );
};

export default InheritsPackageSelect;
